/**
 * S-07: impersonation 完了後に開く tenant-portal URL を組み立てる純関数。
 *
 * 設計:
 *   - tenant-portal は別 origin（TP-33: `{dev-,}portal.tracepit.jp`）のため
 *     Firebase Auth 状態は共有できない。
 *   - そのため tenant-portal 側で `signInWithCustomToken` を実行する前提で、
 *     customToken を URL fragment (`#impersonate_token=...`) に載せて受け渡す。
 *   - fragment は HTTP リクエストに乗らないので Cloud Logging / Hosting access log /
 *     Referer header に記録されない。tenant-portal 側で消費後に history.replaceState で
 *     即座に剥がす運用とセットで利用する。
 *   - クエリ文字列でなく fragment を使うのは、上記の漏洩リスク低減のため。
 *
 * 環境分岐:
 *   - mode === 'production': 独自ドメイン
 *   - それ以外 (development / test): `dev-portal.tracepit.jp`
 */

const PROD_TENANT_PORTAL_URL = 'https://portal.tracepit.jp/';
const DEV_TENANT_PORTAL_URL = 'https://dev-portal.tracepit.jp/';

export interface BuildImpersonationUrlInput {
  customToken: string;
  mode: string;
}

export function buildImpersonationUrl(
  input: BuildImpersonationUrlInput,
): string {
  const base =
    input.mode === 'production' ? PROD_TENANT_PORTAL_URL : DEV_TENANT_PORTAL_URL;
  // fragment 用に encodeURIComponent でエスケープ。tenant-portal 側は `decodeURIComponent` で復号する。
  return `${base}#impersonate_token=${encodeURIComponent(input.customToken)}`;
}

export function getTenantPortalBaseUrl(mode: string): string {
  return mode === 'production' ? PROD_TENANT_PORTAL_URL : DEV_TENANT_PORTAL_URL;
}
